import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withKeys as _withKeys, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-wrap items-start justify-between gap-3" };
const _hoisted_3 = { class: "text-sm font-medium text-eorange-600" };
const _hoisted_4 = { class: "text-2xl font-semibold text-eblack-900" };
const _hoisted_5 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_6 = ["disabled"];
const _hoisted_7 = { class: "grid gap-3 md:grid-cols-2 xl:grid-cols-5" };
const _hoisted_8 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_9 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_10 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_11 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_12 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_13 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_14 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_15 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_16 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_17 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_18 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_19 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_20 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_21 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_22 = { class: "mt-2 text-2xl font-semibold text-eblack-900" };
const _hoisted_23 = {
    key: 0,
    class: "flex flex-wrap items-center justify-between gap-3 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700",
    "data-test": "billing-error"
};
const _hoisted_24 = { class: "grid gap-4 xl:grid-cols-[minmax(0,1fr)_380px]" };
const _hoisted_25 = { class: "rounded-lg border border-ewhite-200 bg-white" };
const _hoisted_26 = { class: "flex items-center justify-between gap-3 border-b border-ewhite-100 p-4" };
const _hoisted_27 = { class: "font-semibold text-eblack-900" };
const _hoisted_28 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_29 = { class: "divide-y divide-ewhite-100" };
const _hoisted_30 = { class: "flex flex-wrap items-center gap-2" };
const _hoisted_31 = { class: "font-medium text-eblack-900" };
const _hoisted_32 = { class: "mt-1 text-xs text-eblack-500" };
const _hoisted_33 = { class: "mt-2 text-sm text-eblack-700" };
const _hoisted_34 = { class: "text-sm text-eblack-600" };
const _hoisted_35 = { class: "font-medium text-eblack-900" };
const _hoisted_36 = { class: "flex items-start justify-end" };
const _hoisted_37 = { class: "flex flex-col gap-2" };
const _hoisted_38 = ["disabled", "onClick"];
const _hoisted_39 = ["disabled", "onClick"];
const _hoisted_40 = {
    key: 0,
    class: "p-4 text-sm text-eblack-500"
};
const _hoisted_41 = { class: "grid gap-4" };
const _hoisted_42 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_43 = { class: "font-semibold text-eblack-900" };
const _hoisted_44 = { class: "mt-3 grid gap-3" };
const _hoisted_45 = ["placeholder"];
const _hoisted_46 = ["placeholder"];
const _hoisted_47 = { class: "grid gap-3 sm:grid-cols-[1fr_90px]" };
const _hoisted_48 = ["placeholder"];
const _hoisted_49 = ["disabled"];
const _hoisted_50 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_51 = { class: "font-semibold text-eblack-900" };
const _hoisted_52 = { class: "mt-3 grid gap-3" };
const _hoisted_53 = { value: "" };
const _hoisted_54 = ["value"];
const _hoisted_55 = { class: "grid gap-3 sm:grid-cols-[1fr_90px]" };
const _hoisted_56 = ["placeholder"];
const _hoisted_57 = ["disabled"];
const _hoisted_58 = { class: "rounded-lg border border-ewhite-200 bg-white" };
const _hoisted_59 = { class: "grid gap-3 border-b border-ewhite-100 p-4 lg:grid-cols-[minmax(180px,1fr)_160px_160px_auto]" };
const _hoisted_60 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_61 = ["placeholder"];
const _hoisted_62 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_63 = { value: "" };
const _hoisted_64 = ["value"];
const _hoisted_65 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_66 = { value: "" };
const _hoisted_67 = { value: "manual" };
const _hoisted_68 = { value: "provider" };
const _hoisted_69 = { class: "flex items-end gap-2" };
const _hoisted_70 = { class: "grid min-h-0 gap-5 xl:grid-cols-[minmax(0,1fr)_430px]" };
const _hoisted_71 = { class: "overflow-hidden rounded-lg border border-ewhite-200 bg-white" };
const _hoisted_72 = { class: "overflow-x-auto" };
const _hoisted_73 = { class: "min-w-[1160px] w-full divide-y divide-ewhite-100 text-left text-sm" };
const _hoisted_74 = { class: "bg-ewhite-50 text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_75 = { class: "px-4 py-3" };
const _hoisted_76 = { class: "px-4 py-3" };
const _hoisted_77 = { class: "px-4 py-3" };
const _hoisted_78 = { class: "px-4 py-3" };
const _hoisted_79 = { class: "px-4 py-3" };
const _hoisted_80 = { class: "px-4 py-3" };
const _hoisted_81 = { class: "px-4 py-3" };
const _hoisted_82 = { class: "divide-y divide-ewhite-100 bg-white" };
const _hoisted_83 = { key: 0 };
const _hoisted_84 = {
    colspan: "7",
    class: "px-4 py-8 text-center text-eblack-500"
};
const _hoisted_85 = { key: 1 };
const _hoisted_86 = {
    colspan: "7",
    class: "px-4 py-8 text-center text-eblack-500"
};
const _hoisted_87 = ["onClick"];
const _hoisted_88 = { class: "px-4 py-3 align-top" };
const _hoisted_89 = { class: "font-medium text-eblack-900" };
const _hoisted_90 = { class: "text-xs text-eblack-500" };
const _hoisted_91 = { class: "px-4 py-3 align-top" };
const _hoisted_92 = { class: "mt-1 text-eblack-700" };
const _hoisted_93 = { class: "text-xs text-eblack-500" };
const _hoisted_94 = { class: "px-4 py-3 align-top text-eblack-700" };
const _hoisted_95 = { class: "px-4 py-3 align-top font-medium text-eblack-900" };
const _hoisted_96 = { class: "px-4 py-3 align-top font-medium text-eblack-900" };
const _hoisted_97 = { class: "px-4 py-3 align-top text-eblack-600" };
const _hoisted_98 = { class: "px-4 py-3 align-top" };
const _hoisted_99 = { class: "flex flex-col gap-4" };
const _hoisted_100 = {
    key: 0,
    class: "rounded-lg border border-ewhite-200 bg-white p-6 text-center text-sm text-eblack-500",
    "data-test": "billing-detail-loading"
};
const _hoisted_101 = {
    key: 1,
    class: "rounded-lg border border-dashed border-ewhite-300 bg-white p-6 text-center text-sm text-eblack-500"
};
const _hoisted_102 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_103 = { class: "flex items-start justify-between gap-3" };
const _hoisted_104 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_105 = { class: "mt-1 text-lg font-semibold text-eblack-900" };
const _hoisted_106 = { class: "text-sm text-eblack-500" };
const _hoisted_107 = ["disabled"];
const _hoisted_108 = { class: "mt-4 grid grid-cols-2 gap-3 text-sm" };
const _hoisted_109 = { class: "text-eblack-500" };
const _hoisted_110 = { class: "font-semibold text-eblack-900" };
const _hoisted_111 = { class: "text-eblack-500" };
const _hoisted_112 = { class: "font-semibold text-eblack-900" };
const _hoisted_113 = { class: "text-eblack-500" };
const _hoisted_114 = { class: "font-semibold text-eblack-900" };
const _hoisted_115 = { class: "text-eblack-500" };
const _hoisted_116 = { class: "font-semibold text-eblack-900" };
const _hoisted_117 = { class: "text-eblack-500" };
const _hoisted_118 = { class: "font-semibold text-eblack-900" };
const _hoisted_119 = { class: "text-eblack-500" };
const _hoisted_120 = { class: "font-semibold text-eblack-900" };
const _hoisted_121 = { class: "mt-4 border-t border-ewhite-100 pt-4" };
const _hoisted_122 = { class: "flex items-center justify-between gap-3" };
const _hoisted_123 = { class: "text-sm font-semibold text-eblack-900" };
const _hoisted_124 = ["disabled"];
const _hoisted_125 = {
    key: 0,
    class: "mt-3 text-sm text-eblack-500"
};
const _hoisted_126 = {
    key: 1,
    class: "mt-3 flex flex-col gap-1 text-sm font-medium text-eblack-700"
};
const _hoisted_127 = ["placeholder"];
const _hoisted_128 = {
    key: 2,
    class: "mt-3 grid gap-2",
    "data-test": "billing-invoice-history"
};
const _hoisted_129 = { class: "flex flex-wrap items-start justify-between gap-2" };
const _hoisted_130 = { class: "font-semibold text-eblack-900" };
const _hoisted_131 = { class: "text-eblack-500" };
const _hoisted_132 = ["href"];
const _hoisted_133 = {
    key: 0,
    class: "mt-2 text-xs text-eblack-500"
};
const _hoisted_134 = { key: 0 };
const _hoisted_135 = {
    key: 1,
    class: "mt-3 grid gap-2 sm:grid-cols-2"
};
const _hoisted_136 = ["disabled", "onClick"];
const _hoisted_137 = ["disabled", "onClick"];
const _hoisted_138 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_139 = { class: "flex items-start justify-between gap-3" };
const _hoisted_140 = { class: "text-xs font-semibold uppercase text-eblack-500" };
const _hoisted_141 = { class: "mt-1 font-semibold text-eblack-900" };
const _hoisted_142 = { class: "mt-1 text-sm text-eblack-500" };
const _hoisted_143 = {
    key: 0,
    class: "mt-3 rounded-lg bg-amber-50 p-3 text-sm text-amber-700",
    "data-test": "billing-provider-disabled"
};
const _hoisted_144 = { class: "mt-4 grid gap-2 text-sm" };
const _hoisted_145 = { class: "flex justify-between gap-3" };
const _hoisted_146 = { class: "text-eblack-500" };
const _hoisted_147 = { class: "font-medium text-eblack-900" };
const _hoisted_148 = { class: "flex justify-between gap-3" };
const _hoisted_149 = { class: "text-eblack-500" };
const _hoisted_150 = { class: "font-medium text-eblack-900" };
const _hoisted_151 = {
    key: 0,
    class: "grid gap-1"
};
const _hoisted_152 = { class: "text-eblack-500" };
const _hoisted_153 = { class: "break-all font-mono text-xs text-eblack-700" };
const _hoisted_154 = {
    key: 1,
    class: "grid gap-1"
};
const _hoisted_155 = { class: "text-eblack-500" };
const _hoisted_156 = { class: "break-all font-mono text-xs text-eblack-700" };
const _hoisted_157 = {
    key: 2,
    class: "grid gap-1"
};
const _hoisted_158 = { class: "text-red-700" };
const _hoisted_159 = { class: "text-sm text-red-700" };
const _hoisted_160 = { class: "mt-4 grid gap-3" };
const _hoisted_161 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_162 = ["placeholder"];
const _hoisted_163 = { class: "flex items-center gap-2 text-sm text-eblack-700" };
const _hoisted_164 = { class: "grid gap-2 sm:grid-cols-2" };
const _hoisted_165 = ["disabled"];
const _hoisted_166 = ["disabled"];
const _hoisted_167 = ["disabled"];
const _hoisted_168 = ["disabled"];
const _hoisted_169 = ["disabled"];
const _hoisted_170 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_171 = { class: "font-semibold text-eblack-900" };
const _hoisted_172 = { class: "mt-3 grid gap-3" };
const _hoisted_173 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_174 = { value: "" };
const _hoisted_175 = ["value"];
const _hoisted_176 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_177 = { value: "" };
const _hoisted_178 = ["value"];
const _hoisted_179 = { class: "grid gap-3" };
const _hoisted_180 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_181 = ["value"];
const _hoisted_182 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_183 = { class: "grid gap-3 sm:grid-cols-[1fr_100px]" };
const _hoisted_184 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_185 = ["placeholder"];
const _hoisted_186 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_187 = { class: "grid gap-3 sm:grid-cols-3" };
const _hoisted_188 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_189 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_190 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_191 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_192 = ["placeholder"];
const _hoisted_193 = ["disabled"];
const _hoisted_194 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_195 = { class: "font-semibold text-eblack-900" };
const _hoisted_196 = { class: "mt-3 grid gap-3 sm:grid-cols-[1fr_120px_auto]" };
const _hoisted_197 = { value: "" };
const _hoisted_198 = ["value"];
const _hoisted_199 = ["aria-label"];
const _hoisted_200 = ["disabled"];
const _hoisted_201 = {
    key: 0,
    class: "mt-3 grid gap-2 rounded-lg bg-ewhite-50 p-3 text-sm text-eblack-700",
    "data-test": "billing-preview-result"
};
const _hoisted_202 = { class: "flex justify-between gap-3" };
const _hoisted_203 = { class: "flex justify-between gap-3" };
const _hoisted_204 = { class: "rounded-lg border border-ewhite-200 bg-white p-4" };
const _hoisted_205 = { class: "font-semibold text-eblack-900" };
const _hoisted_206 = { class: "mt-3 grid gap-3" };
const _hoisted_207 = { class: "grid gap-3 sm:grid-cols-[1fr_100px]" };
const _hoisted_208 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_209 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_210 = { class: "flex flex-col gap-1 text-sm font-medium text-eblack-700" };
const _hoisted_211 = ["placeholder"];
const _hoisted_212 = ["disabled"];
const _hoisted_213 = {
    key: 0,
    class: "mt-4 grid gap-3 rounded-lg bg-ewhite-50 p-3 text-sm"
};
const _hoisted_214 = { class: "flex flex-wrap items-center justify-between gap-2" };
const _hoisted_215 = { class: "font-medium text-eblack-900" };
const _hoisted_216 = { class: "text-eblack-500" };
const _hoisted_217 = { class: "flex flex-col gap-1 font-medium text-eblack-700" };
const _hoisted_218 = ["placeholder"];
const _hoisted_219 = { class: "grid gap-2 sm:grid-cols-2" };
const _hoisted_220 = ["disabled"];
const _hoisted_221 = ["disabled"];
import { computed, onMounted, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useToast } from "vue-toastification";
import ConfirmModal from "@/components/ui/ConfirmModal.vue";
import { IconDeviceFloppy, IconPlus, IconReceipt, IconRefresh, IconUsers, } from "@tabler/icons-vue";
import { useBillingStore, useBillingFormatting } from "@/domains/billing";
import { useFeatureFlagStore } from "@/domains/feature-flags";
import { FEATURE_FLAGS } from "@/constants/feature-flags";
export default /*@__PURE__*/ _defineComponent({
    __name: 'GlobalBillingIndex',
    setup(__props) {
        const store = useBillingStore();
        const featureFlagStore = useFeatureFlagStore();
        const toast = useToast();
        const { t } = useI18n();
        const { money, dateLabel, statusLabel, modeLabel, actionLabel, invoiceLabel, priceSourceLabel, statusClass, actionClass, } = useBillingFormatting();
        const statusOptions = [
            "manual",
            "trialing",
            "active",
            "grace",
            "past_due",
            "cancelled",
            "paused",
        ];
        const filters = reactive({
            search: "",
            status: "",
            billing_mode: "",
        });
        const updateForm = reactive({
            plan_id: "",
            plan_price_id: "",
            status: "manual",
            billable_seat_count: 0,
            custom_amount: "",
            custom_currency: "USD",
            trial_ends_at: "",
            grace_ends_at: "",
            cancel_at: "",
            reason: "",
        });
        const previewForm = reactive({
            plan_id: "",
            billable_seat_count: 0,
        });
        const invoiceForm = reactive({
            amount: "",
            currency: "USD",
            reason: "",
        });
        const invoiceActionForm = reactive({
            reason: "",
        });
        const providerActionForm = reactive({
            reason: "",
            cancel_at_period_end: true,
        });
        const planForm = reactive({
            name: "",
            code: "",
            amount: "80.00",
            currency: "USD",
        });
        const priceForm = reactive({
            plan_id: "",
            amount: "",
            currency: "USD",
            effective_from: "",
        });
        const subscriptions = computed(() => store.platformSubscriptions);
        const selected = computed(() => store.selectedSubscription);
        const hasSubmittedProof = computed(() => store.platformInvoices.some((invoice) => invoice.proof.status === "submitted"));
        const activePlans = computed(() => store.plans.filter((plan) => plan.status === "active"));
        const selectedPlanPriceVersions = computed(() => {
            const plan = store.plans.find((item) => item.id === updateForm.plan_id);
            return plan?.price_versions ?? [];
        });
        const canUseItineraryPayments = computed(() => featureFlagStore.isGlobalEnabled(FEATURE_FLAGS.ITINERARY_ONVO_PAYMENTS));
        const canUseProviderBilling = computed(() => featureFlagStore.isGlobalEnabled(FEATURE_FLAGS.ORGANIZATION_BILLING_ONVO));
        const canRunProviderAction = computed(() => Boolean(selected.value && providerActionForm.reason) &&
            canUseProviderBilling.value &&
            !store.isSaving);
        const canCreateInvoice = computed(() => {
            const amount = Number(invoiceForm.amount);
            return ((!invoiceForm.amount || amount > 0) &&
                invoiceForm.currency.trim().length === 3);
        });
        const canMarkInvoicePaid = computed(() => selected.value?.invoice.status === "open" &&
            Boolean(invoiceActionForm.reason));
        const canVoidInvoice = computed(() => selected.value?.invoice.status === "open" &&
            Boolean(invoiceActionForm.reason));
        const canCreatePlan = computed(() => Boolean(planForm.name && planForm.code) &&
            Number(planForm.amount) >= 0 &&
            planForm.currency.trim().length === 3);
        const canCreatePriceVersion = computed(() => Boolean(priceForm.plan_id) &&
            Number(priceForm.amount) >= 0 &&
            priceForm.currency.trim().length === 3);
        const pendingProviderAction = ref(null);
        const pendingProviderActionMessage = computed(() => {
            switch (pendingProviderAction.value) {
                case "migrate":
                    return t("settings.billing.provider.confirm_migrate");
                case "sync-seats":
                    return t("settings.billing.provider.confirm_sync_seats");
                case "change-plan":
                    return t("settings.billing.provider.confirm_change_plan");
                case "cancel":
                    return t("settings.billing.provider.confirm_cancel");
                default:
                    return "";
            }
        });
        onMounted(async () => {
            await Promise.all([store.fetchPlans(), refresh()]);
        });
        watch(selected, (next) => {
            if (next)
                seedForms(next);
        });
        async function refresh() {
            const items = await store.fetchPlatformSubscriptions({
                search: filters.search || undefined,
                status: filters.status || undefined,
                billing_mode: filters.billing_mode || undefined,
                limit: 25,
                offset: 0,
            });
            if (!store.selectedSubscription && items[0]) {
                await selectSubscription(items[0]);
            }
        }
        async function applyFilters() {
            store.selectedSubscription = null;
            await refresh();
        }
        async function clearFilters() {
            filters.search = "";
            filters.status = "";
            filters.billing_mode = "";
            await applyFilters();
        }
        async function selectSubscription(item) {
            await store.fetchPlatformDetail(item.organization.id);
            await store.fetchPlatformInvoices(item.organization.id);
        }
        async function fetchSelectedInvoices() {
            if (!selected.value)
                return;
            await store.fetchPlatformInvoices(selected.value.organization.id);
        }
        async function syncSeats() {
            if (!selected.value)
                return;
            await store.syncSeats(selected.value.organization.id, {
                reason: t("settings.billing.audit.sync_reason"),
            });
            toast.success(t("settings.billing.toasts.seats_synced"));
        }
        async function saveSubscription() {
            if (!selected.value || !updateForm.reason)
                return;
            await store.updateSubscription(selected.value.organization.id, {
                plan_id: updateForm.plan_id || null,
                plan_price_id: updateForm.plan_price_id || null,
                status: updateForm.status,
                billable_seat_count: updateForm.billable_seat_count,
                custom_unit_amount_minor: amountInputToMinorOrNull(updateForm.custom_amount),
                custom_currency: updateForm.custom_amount && updateForm.custom_currency
                    ? updateForm.custom_currency.toUpperCase()
                    : null,
                trial_ends_at: inputDateToIso(updateForm.trial_ends_at),
                grace_ends_at: inputDateToIso(updateForm.grace_ends_at),
                cancel_at: inputDateToIso(updateForm.cancel_at),
                reason: updateForm.reason,
            });
            updateForm.reason = "";
            toast.success(t("settings.billing.toasts.subscription_updated"));
        }
        async function previewCharge() {
            if (!selected.value)
                return;
            await store.previewCharge(selected.value.organization.id, {
                plan_id: previewForm.plan_id || undefined,
                billable_seat_count: previewForm.billable_seat_count,
            });
        }
        async function createManualInvoice() {
            if (!selected.value || !canCreateInvoice.value)
                return;
            const amountMinor = amountInputToMinorOrNull(invoiceForm.amount);
            await store.createManualInvoice(selected.value.organization.id, {
                amount_minor: amountMinor ?? undefined,
                currency: invoiceForm.currency.toUpperCase(),
                reason: invoiceForm.reason || undefined,
            });
            invoiceForm.amount = "";
            invoiceForm.reason = "";
            await fetchSelectedInvoices();
            toast.success(t("settings.billing.toasts.invoice_created"));
        }
        async function markInvoicePaid() {
            if (!selected.value?.invoice.id || !canMarkInvoicePaid.value)
                return;
            await store.markInvoicePaid(selected.value.invoice.id, {
                reason: invoiceActionForm.reason,
            });
            invoiceActionForm.reason = "";
            await fetchSelectedInvoices();
            toast.success(t("settings.billing.toasts.invoice_paid"));
        }
        async function markHistoryInvoicePaid(invoiceId) {
            if (!selected.value || !invoiceActionForm.reason)
                return;
            await store.markInvoicePaid(invoiceId, { reason: invoiceActionForm.reason });
            invoiceActionForm.reason = "";
            await fetchSelectedInvoices();
            toast.success(t("settings.billing.toasts.invoice_paid"));
        }
        async function rejectInvoiceProof(invoiceId) {
            if (!invoiceActionForm.reason)
                return;
            await store.rejectInvoiceProof(invoiceId, { reason: invoiceActionForm.reason });
            invoiceActionForm.reason = "";
            toast.success(t("settings.billing.toasts.invoice_proof_rejected"));
        }
        async function voidInvoice() {
            if (!selected.value?.invoice.id || !canVoidInvoice.value)
                return;
            await store.voidInvoice(selected.value.invoice.id, {
                reason: invoiceActionForm.reason,
            });
            invoiceActionForm.reason = "";
            await fetchSelectedInvoices();
            toast.success(t("settings.billing.toasts.invoice_voided"));
        }
        async function createPlan() {
            if (!canCreatePlan.value)
                return;
            await store.createPlan({
                name: planForm.name,
                code: planForm.code,
                billing_interval: "monthly",
                unit_amount_minor: Math.round(Number(planForm.amount) * 100),
                currency: planForm.currency.toUpperCase(),
            });
            planForm.name = "";
            planForm.code = "";
            planForm.amount = "80.00";
            toast.success(t("settings.billing.toasts.plan_created"));
        }
        async function createPriceVersion() {
            if (!canCreatePriceVersion.value)
                return;
            await store.createPlanPriceVersion(priceForm.plan_id, {
                unit_amount_minor: Math.round(Number(priceForm.amount) * 100),
                currency: priceForm.currency.toUpperCase(),
                billing_interval: "monthly",
                effective_from: inputDateToIso(priceForm.effective_from) ?? undefined,
            });
            priceForm.amount = "";
            priceForm.effective_from = "";
            toast.success(t("settings.billing.toasts.price_created"));
        }
        async function syncPlanPrice(plan) {
            if (!plan.price.id || !providerActionForm.reason) {
                providerActionForm.reason ||= t("settings.billing.audit.provider_price_sync");
            }
            if (!plan.price.id)
                return;
            await store.syncPlanPriceToProvider(plan.id, plan.price.id, {
                provider: "onvo",
                reason: providerActionForm.reason ||
                    t("settings.billing.audit.provider_price_sync"),
            });
            toast.success(t("settings.billing.toasts.provider_price_synced"));
        }
        function requestProviderAction(type) {
            if (type === "change-plan" && !updateForm.plan_id)
                return;
            if (!selected.value || !canRunProviderAction.value)
                return;
            pendingProviderAction.value = type;
        }
        async function runPendingProviderAction() {
            const type = pendingProviderAction.value;
            if (!type)
                return;
            switch (type) {
                case "migrate":
                    await migrateProvider();
                    break;
                case "sync-seats":
                    await syncProviderSeats();
                    break;
                case "change-plan":
                    await changeProviderPlan();
                    break;
                case "cancel":
                    await cancelProvider();
                    break;
            }
            pendingProviderAction.value = null;
        }
        async function migrateProvider() {
            if (!selected.value || !canRunProviderAction.value)
                return;
            await store.migrateToProvider(selected.value.organization.id, {
                provider: "onvo",
                reason: providerActionForm.reason,
            });
            clearProviderReason();
            toast.success(t("settings.billing.toasts.provider_migrated"));
        }
        async function syncProvider() {
            if (!selected.value || !canRunProviderAction.value)
                return;
            await store.syncProviderSubscription(selected.value.organization.id, {
                provider: "onvo",
                reason: providerActionForm.reason,
            });
            clearProviderReason();
            toast.success(t("settings.billing.toasts.provider_synced"));
        }
        async function syncProviderSeats() {
            if (!selected.value || !canRunProviderAction.value)
                return;
            await store.syncProviderSeats(selected.value.organization.id, {
                provider: "onvo",
                reason: providerActionForm.reason,
            });
            clearProviderReason();
            toast.success(t("settings.billing.toasts.provider_seats_synced"));
        }
        async function changeProviderPlan() {
            if (!selected.value || !canRunProviderAction.value || !updateForm.plan_id) {
                return;
            }
            await store.changeProviderPlan(selected.value.organization.id, {
                provider: "onvo",
                plan_id: updateForm.plan_id,
                plan_price_id: updateForm.plan_price_id || undefined,
                reason: providerActionForm.reason,
            });
            clearProviderReason();
            toast.success(t("settings.billing.toasts.provider_plan_changed"));
        }
        async function cancelProvider() {
            if (!selected.value || !canRunProviderAction.value)
                return;
            await store.cancelProviderSubscription(selected.value.organization.id, {
                provider: "onvo",
                cancel_at_period_end: providerActionForm.cancel_at_period_end,
                reason: providerActionForm.reason,
            });
            clearProviderReason();
            toast.success(t("settings.billing.toasts.provider_cancelled"));
        }
        async function togglePlanStatus(plan) {
            await store.updatePlan(plan.id, {
                status: plan.status === "active" ? "archived" : "active",
            });
            toast.success(t("settings.billing.toasts.plan_updated"));
        }
        function clearProviderReason() {
            providerActionForm.reason = "";
        }
        function seedForms(subscription) {
            updateForm.plan_id = subscription.subscription.plan_id ?? "";
            updateForm.plan_price_id = subscription.subscription.plan_price_id ?? "";
            updateForm.status = statusOptions.includes(subscription.subscription.status)
                ? subscription.subscription.status
                : "manual";
            updateForm.billable_seat_count = subscription.seats.billable_seats;
            updateForm.custom_amount =
                subscription.subscription.custom_unit_amount_minor == null
                    ? ""
                    : minorToInput(subscription.subscription.custom_unit_amount_minor);
            updateForm.custom_currency =
                subscription.subscription.custom_currency ??
                    subscription.amounts.currency ??
                    "USD";
            updateForm.trial_ends_at = isoToInputDate(subscription.lifecycle.trial_ends_at);
            updateForm.grace_ends_at = isoToInputDate(subscription.lifecycle.grace_ends_at);
            updateForm.cancel_at = isoToInputDate(subscription.lifecycle.cancel_at);
            previewForm.plan_id = subscription.subscription.plan_id ?? "";
            previewForm.billable_seat_count = subscription.seats.billable_seats;
            invoiceForm.amount = minorToInput(subscription.amounts.expected_monthly_charge_minor);
            invoiceForm.currency = subscription.amounts.currency ?? "USD";
            invoiceActionForm.reason = "";
            providerActionForm.reason = "";
        }
        function providerName(item) {
            if (!item.provider.provider)
                return t("settings.billing.provider.none");
            if (item.provider.provider === "onvo")
                return "ONVO";
            return item.provider.provider;
        }
        function providerStatusLabel(item) {
            return (item.provider.subscription.provider_status ||
                item.provider.account.status ||
                t("settings.billing.provider.no_provider_status"));
        }
        function providerLastError(item) {
            return (item.provider.subscription.last_error ||
                item.provider.account.last_error ||
                item.provider.plan_price.last_error);
        }
        function isoToInputDate(value) {
            if (!value)
                return "";
            return value.slice(0, 10);
        }
        function inputDateToIso(value) {
            if (!value)
                return null;
            return `${value}T00:00:00.000Z`;
        }
        function minorToInput(amountMinor) {
            return ((amountMinor ?? 0) / 100).toFixed(2);
        }
        function amountInputToMinorOrNull(value) {
            if (!value.trim())
                return null;
            return Math.round(Number(value) * 100);
        }
        return (_ctx, _cache) => {
            const _component_router_link = _resolveComponent("router-link");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("section", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(t)("settings.billing.global.eyebrow")), 1),
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(t)("settings.billing.global.title")), 1),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)("settings.billing.global.description")), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex h-9 items-center gap-2 rounded-lg border border-ewhite-200 bg-white px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                        disabled: _unref(store).isLoading,
                        "data-test": "billing-refresh",
                        onClick: refresh
                    }, [
                        _createVNode(_unref(IconRefresh), { class: "h-4 w-4" }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.actions.refresh")), 1)
                    ], 8, _hoisted_6),
                    (canUseItineraryPayments.value)
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 0,
                            to: "/admin/global/billing/payments",
                            class: "inline-flex h-9 items-center rounded-lg border border-ewhite-200 bg-white px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50",
                            "data-test": "billing-payments-tab"
                        }, {
                            default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.tabs.payments")), 1)
                            ]),
                            _: 1
                        }))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("section", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("p", _hoisted_9, _toDisplayString(_unref(t)("settings.billing.cards.organizations")), 1),
                        _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(store).pagination.total), 1)
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)("settings.billing.cards.expected")), 1),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(money)(_unref(store).expectedMonthlyChargeMinor, "USD")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)("settings.billing.cards.open_balance")), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(money)(_unref(store).totalAmountDueMinor, "USD")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("settings.billing.cards.ready_to_invoice")), 1),
                        _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(store).readyToInvoiceCount), 1)
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)("settings.billing.cards.attention")), 1),
                        _createElementVNode("p", _hoisted_22, _toDisplayString(_unref(store).attentionCount), 1)
                    ])
                ]),
                (_unref(store).error)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_23, [
                        _createElementVNode("span", null, _toDisplayString(_unref(store).error), 1),
                        _createElementVNode("button", {
                            type: "button",
                            class: "rounded-md border border-red-200 px-2.5 py-1 font-medium hover:bg-red-100",
                            onClick: refresh
                        }, _toDisplayString(_unref(t)("settings.billing.actions.retry")), 1)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", _hoisted_26, [
                            _createElementVNode("div", null, [
                                _createElementVNode("h2", _hoisted_27, _toDisplayString(_unref(t)("settings.billing.plans.title")), 1),
                                _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(t)("settings.billing.plans.description")), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).plans, (plan) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: plan.id,
                                    class: "grid gap-3 p-4 lg:grid-cols-[minmax(0,1fr)_220px_auto]",
                                    "data-test": "billing-plan-row"
                                }, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("div", _hoisted_30, [
                                            _createElementVNode("p", _hoisted_31, _toDisplayString(plan.name), 1),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["rounded-full px-2 py-0.5 text-xs font-semibold",
                                                    plan.status === 'active'
                                                        ? 'bg-egreen-100 text-egreen-700'
                                                        : 'bg-ewhite-100 text-eblack-500'
                                                ])
                                            }, _toDisplayString(plan.status), 3)
                                        ]),
                                        _createElementVNode("p", _hoisted_32, _toDisplayString(plan.code) + " · " + _toDisplayString(plan.billing_interval), 1),
                                        _createElementVNode("p", _hoisted_33, [
                                            _createTextVNode(_toDisplayString(_unref(t)("settings.billing.plans.current_price")) + ": ", 1),
                                            _createElementVNode("strong", null, _toDisplayString(_unref(money)(plan.price.unit_amount_minor, plan.price.currency)), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                        _createElementVNode("p", _hoisted_35, _toDisplayString(_unref(t)("settings.billing.plans.versions")), 1),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.price_versions.slice(0, 3), (price) => {
                                            return (_openBlock(), _createElementBlock("p", {
                                                key: price.id,
                                                class: "mt-1"
                                            }, [
                                                _createTextVNode(_toDisplayString(_unref(money)(price.unit_amount_minor, price.currency)) + " ", 1),
                                                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "text-eblack-400" }, "·", -1)),
                                                _createTextVNode(" " + _toDisplayString(_unref(dateLabel)(price.effective_from)), 1)
                                            ]));
                                        }), 128))
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                        _createElementVNode("div", _hoisted_37, [
                                            (canUseProviderBilling.value && plan.price.id)
                                                ? (_openBlock(), _createElementBlock("button", {
                                                    key: 0,
                                                    type: "button",
                                                    class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                    disabled: _unref(store).isSaving,
                                                    "data-test": "billing-sync-provider-price",
                                                    onClick: ($event) => (syncPlanPrice(plan))
                                                }, _toDisplayString(_unref(t)("settings.billing.provider.sync_price")), 9, _hoisted_38))
                                                : _createCommentVNode("", true),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                disabled: _unref(store).isSaving,
                                                "data-test": "billing-toggle-plan",
                                                onClick: ($event) => (togglePlanStatus(plan))
                                            }, _toDisplayString(plan.status === "active"
                                                ? _unref(t)("settings.billing.actions.archive_plan")
                                                : _unref(t)("settings.billing.actions.restore_plan")), 9, _hoisted_39)
                                        ])
                                    ])
                                ]));
                            }), 128)),
                            (!_unref(store).isLoadingPlans && _unref(store).plans.length === 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_40, _toDisplayString(_unref(t)("settings.billing.plans.empty")), 1))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("section", _hoisted_42, [
                            _createElementVNode("h3", _hoisted_43, _toDisplayString(_unref(t)("settings.billing.plans.create_title")), 1),
                            _createElementVNode("div", _hoisted_44, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((planForm.name) = $event)),
                                    class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                    placeholder: _unref(t)('settings.billing.fields.plan_name')
                                }, null, 8, _hoisted_45), [
                                    [
                                        _vModelText,
                                        planForm.name,
                                        void 0,
                                        { trim: true }
                                    ]
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((planForm.code) = $event)),
                                    class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                    placeholder: _unref(t)('settings.billing.fields.plan_code')
                                }, null, 8, _hoisted_46), [
                                    [
                                        _vModelText,
                                        planForm.code,
                                        void 0,
                                        { trim: true }
                                    ]
                                ]),
                                _createElementVNode("div", _hoisted_47, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((planForm.amount) = $event)),
                                        inputmode: "decimal",
                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                        placeholder: _unref(t)('settings.billing.fields.amount')
                                    }, null, 8, _hoisted_48), [
                                        [_vModelText, planForm.amount]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((planForm.currency) = $event)),
                                        maxlength: "3",
                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm uppercase"
                                    }, null, 512), [
                                        [
                                            _vModelText,
                                            planForm.currency,
                                            void 0,
                                            { trim: true }
                                        ]
                                    ])
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "inline-flex h-9 items-center justify-center gap-2 rounded-lg bg-eblack-900 px-3 text-sm font-semibold text-white hover:bg-eblack-800 disabled:opacity-60",
                                    disabled: _unref(store).isSaving || !canCreatePlan.value,
                                    "data-test": "billing-create-plan",
                                    onClick: createPlan
                                }, [
                                    _createVNode(_unref(IconPlus), { class: "h-4 w-4" }),
                                    _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.actions.create_plan")), 1)
                                ], 8, _hoisted_49)
                            ])
                        ]),
                        _createElementVNode("section", _hoisted_50, [
                            _createElementVNode("h3", _hoisted_51, _toDisplayString(_unref(t)("settings.billing.plans.price_title")), 1),
                            _createElementVNode("div", _hoisted_52, [
                                _withDirectives(_createElementVNode("select", {
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((priceForm.plan_id) = $event)),
                                    class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm"
                                }, [
                                    _createElementVNode("option", _hoisted_53, _toDisplayString(_unref(t)("settings.billing.fields.plan")), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).plans, (plan) => {
                                        return (_openBlock(), _createElementBlock("option", {
                                            key: plan.id,
                                            value: plan.id
                                        }, _toDisplayString(plan.name), 9, _hoisted_54));
                                    }), 128))
                                ], 512), [
                                    [_vModelSelect, priceForm.plan_id]
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((priceForm.amount) = $event)),
                                        inputmode: "decimal",
                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                        placeholder: _unref(t)('settings.billing.fields.amount')
                                    }, null, 8, _hoisted_56), [
                                        [_vModelText, priceForm.amount]
                                    ]),
                                    _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((priceForm.currency) = $event)),
                                        maxlength: "3",
                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm uppercase"
                                    }, null, 512), [
                                        [
                                            _vModelText,
                                            priceForm.currency,
                                            void 0,
                                            { trim: true }
                                        ]
                                    ])
                                ]),
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((priceForm.effective_from) = $event)),
                                    type: "date",
                                    class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm"
                                }, null, 512), [
                                    [_vModelText, priceForm.effective_from]
                                ]),
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                    disabled: _unref(store).isSaving || !canCreatePriceVersion.value,
                                    "data-test": "billing-create-price",
                                    onClick: createPriceVersion
                                }, _toDisplayString(_unref(t)("settings.billing.actions.create_price")), 9, _hoisted_57)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("label", _hoisted_60, [
                            _createTextVNode(_toDisplayString(_unref(t)("settings.billing.filters.search")) + " ", 1),
                            _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((filters.search) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                "data-test": "billing-search",
                                placeholder: _unref(t)('settings.billing.filters.search_placeholder'),
                                onKeydown: _withKeys(applyFilters, ["enter"])
                            }, null, 40, _hoisted_61), [
                                [
                                    _vModelText,
                                    filters.search,
                                    void 0,
                                    { trim: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_62, [
                            _createTextVNode(_toDisplayString(_unref(t)("settings.billing.filters.status")) + " ", 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((filters.status) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm",
                                "data-test": "billing-status-filter",
                                onChange: applyFilters
                            }, [
                                _createElementVNode("option", _hoisted_63, _toDisplayString(_unref(t)("settings.billing.filters.any_status")), 1),
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (status) => {
                                    return _createElementVNode("option", {
                                        key: status,
                                        value: status
                                    }, _toDisplayString(_unref(statusLabel)(status)), 9, _hoisted_64);
                                }), 64))
                            ], 544), [
                                [_vModelSelect, filters.status]
                            ])
                        ]),
                        _createElementVNode("label", _hoisted_65, [
                            _createTextVNode(_toDisplayString(_unref(t)("settings.billing.filters.mode")) + " ", 1),
                            _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((filters.billing_mode) = $event)),
                                class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm",
                                "data-test": "billing-mode-filter",
                                onChange: applyFilters
                            }, [
                                _createElementVNode("option", _hoisted_66, _toDisplayString(_unref(t)("settings.billing.filters.any_mode")), 1),
                                _createElementVNode("option", _hoisted_67, _toDisplayString(_unref(t)("settings.billing.modes.manual")), 1),
                                _createElementVNode("option", _hoisted_68, _toDisplayString(_unref(t)("settings.billing.modes.provider")), 1)
                            ], 544), [
                                [_vModelSelect, filters.billing_mode]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50",
                                "data-test": "billing-apply",
                                onClick: applyFilters
                            }, _toDisplayString(_unref(t)("settings.billing.actions.apply")), 1),
                            _createElementVNode("button", {
                                type: "button",
                                class: "h-9 rounded-lg px-3 text-sm font-medium text-eblack-500 hover:bg-ewhite-50",
                                "data-test": "billing-clear",
                                onClick: clearFilters
                            }, _toDisplayString(_unref(t)("settings.billing.actions.clear")), 1)
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("div", _hoisted_72, [
                            _createElementVNode("table", _hoisted_73, [
                                _createElementVNode("thead", _hoisted_74, [
                                    _createElementVNode("tr", null, [
                                        _createElementVNode("th", _hoisted_75, _toDisplayString(_unref(t)("settings.billing.table.org")), 1),
                                        _createElementVNode("th", _hoisted_76, _toDisplayString(_unref(t)("settings.billing.table.plan")), 1),
                                        _createElementVNode("th", _hoisted_77, _toDisplayString(_unref(t)("settings.billing.table.seats")), 1),
                                        _createElementVNode("th", _hoisted_78, _toDisplayString(_unref(t)("settings.billing.table.expected")), 1),
                                        _createElementVNode("th", _hoisted_79, _toDisplayString(_unref(t)("settings.billing.table.open_balance")), 1),
                                        _createElementVNode("th", _hoisted_80, _toDisplayString(_unref(t)("settings.billing.table.next_charge")), 1),
                                        _createElementVNode("th", _hoisted_81, _toDisplayString(_unref(t)("settings.billing.table.action")), 1)
                                    ])
                                ]),
                                _createElementVNode("tbody", _hoisted_82, [
                                    (_unref(store).isLoading)
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_83, [
                                            _createElementVNode("td", _hoisted_84, _toDisplayString(_unref(t)("settings.billing.loading")), 1)
                                        ]))
                                        : (subscriptions.value.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_85, [
                                                _createElementVNode("td", _hoisted_86, _toDisplayString(_unref(t)("settings.billing.empty")), 1)
                                            ]))
                                            : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(subscriptions.value, (item) => {
                                                return (_openBlock(), _createElementBlock("tr", {
                                                    key: item.organization.id,
                                                    class: _normalizeClass(["cursor-pointer transition-colors hover:bg-ewhite-50",
                                                        selected.value?.organization.id === item.organization.id
                                                            ? 'bg-eorange-50'
                                                            : ''
                                                    ]),
                                                    "data-test": "billing-row",
                                                    onClick: ($event) => (selectSubscription(item))
                                                }, [
                                                    _createElementVNode("td", _hoisted_88, [
                                                        _createElementVNode("p", _hoisted_89, _toDisplayString(item.organization.display_name), 1),
                                                        _createElementVNode("p", _hoisted_90, " #" + _toDisplayString(item.organization.id) + " - " + _toDisplayString(item.organization.org_type), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_91, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["inline-flex rounded-full px-2 py-0.5 text-xs font-semibold", _unref(statusClass)(item.subscription.status)])
                                                        }, _toDisplayString(_unref(statusLabel)(item.subscription.status)), 3),
                                                        _createElementVNode("p", _hoisted_92, _toDisplayString(item.subscription.plan_name ||
                                                            _unref(t)("settings.billing.none")), 1),
                                                        _createElementVNode("p", _hoisted_93, _toDisplayString(_unref(modeLabel)(item.subscription.billing_mode)), 1)
                                                    ]),
                                                    _createElementVNode("td", _hoisted_94, _toDisplayString(item.seats.billable_seats) + " / " + _toDisplayString(item.seats.active_seats), 1),
                                                    _createElementVNode("td", _hoisted_95, _toDisplayString(_unref(money)(item.amounts.expected_monthly_charge_minor, item.amounts.currency)), 1),
                                                    _createElementVNode("td", _hoisted_96, _toDisplayString(_unref(money)(item.amounts.open_invoice_amount_minor, item.amounts.currency)), 1),
                                                    _createElementVNode("td", _hoisted_97, _toDisplayString(_unref(dateLabel)(item.lifecycle.next_charge_at)), 1),
                                                    _createElementVNode("td", _hoisted_98, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["inline-flex max-w-[220px] rounded-full px-2 py-0.5 text-xs font-semibold", _unref(actionClass)(item.recommended_action.severity)])
                                                        }, _toDisplayString(_unref(actionLabel)(item.recommended_action.code)), 3)
                                                    ])
                                                ], 10, _hoisted_87));
                                            }), 128))
                                ])
                            ])
                        ])
                    ]),
                    _createElementVNode("aside", _hoisted_99, [
                        (_unref(store).isLoadingDetail)
                            ? (_openBlock(), _createElementBlock("section", _hoisted_100, _toDisplayString(_unref(t)("settings.billing.loading")), 1))
                            : (!selected.value)
                                ? (_openBlock(), _createElementBlock("section", _hoisted_101, _toDisplayString(_unref(t)("settings.billing.global.select_prompt")), 1))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("section", _hoisted_102, [
                                        _createElementVNode("div", _hoisted_103, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_104, _toDisplayString(_unref(t)("settings.billing.detail.selected")), 1),
                                                _createElementVNode("h2", _hoisted_105, _toDisplayString(selected.value.organization.display_name), 1),
                                                _createElementVNode("p", _hoisted_106, _toDisplayString(selected.value.subscription.plan_name ||
                                                    _unref(t)("settings.billing.none")), 1)
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "inline-flex h-8 items-center gap-1 rounded-lg border border-ewhite-200 px-2.5 text-xs font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                disabled: _unref(store).isSaving,
                                                "data-test": "billing-sync-seats",
                                                onClick: syncSeats
                                            }, [
                                                _createVNode(_unref(IconUsers), { class: "h-4 w-4" }),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.actions.sync_seats")), 1)
                                            ], 8, _hoisted_107)
                                        ]),
                                        _createElementVNode("div", _hoisted_108, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_109, _toDisplayString(_unref(t)("settings.billing.detail.billable")), 1),
                                                _createElementVNode("p", _hoisted_110, _toDisplayString(selected.value.seats.billable_seats), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_111, _toDisplayString(_unref(t)("settings.billing.detail.active")), 1),
                                                _createElementVNode("p", _hoisted_112, _toDisplayString(selected.value.seats.active_seats), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_113, _toDisplayString(_unref(t)("settings.billing.detail.expected")), 1),
                                                _createElementVNode("p", _hoisted_114, _toDisplayString(_unref(money)(selected.value.amounts.expected_monthly_charge_minor, selected.value.amounts.currency)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_115, _toDisplayString(_unref(t)("settings.billing.detail.open_balance")), 1),
                                                _createElementVNode("p", _hoisted_116, _toDisplayString(_unref(money)(selected.value.amounts.open_invoice_amount_minor, selected.value.amounts.currency)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_117, _toDisplayString(_unref(t)("settings.billing.detail.unit_price")), 1),
                                                _createElementVNode("p", _hoisted_118, _toDisplayString(_unref(money)(selected.value.seats.seat_unit_amount_minor, selected.value.amounts.currency)), 1)
                                            ]),
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_119, _toDisplayString(_unref(t)("settings.billing.detail.price_source")), 1),
                                                _createElementVNode("p", _hoisted_120, _toDisplayString(_unref(priceSourceLabel)(selected.value.amounts.price_source)), 1)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_121, [
                                            _createElementVNode("div", _hoisted_122, [
                                                _createElementVNode("h4", _hoisted_123, _toDisplayString(_unref(t)("settings.billing.detail.invoice_history")), 1),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "rounded-lg border border-ewhite-200 px-2.5 py-1 text-xs font-semibold text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                    disabled: _unref(store).isLoadingDetail,
                                                    "data-test": "billing-refresh-invoices",
                                                    onClick: fetchSelectedInvoices
                                                }, _toDisplayString(_unref(t)("settings.billing.actions.refresh")), 9, _hoisted_124)
                                            ]),
                                            (_unref(store).platformInvoices.length === 0)
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_125, _toDisplayString(_unref(t)("settings.billing.detail.no_invoices")), 1))
                                                : _createCommentVNode("", true),
                                            (hasSubmittedProof.value)
                                                ? (_openBlock(), _createElementBlock("label", _hoisted_126, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.reason")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((invoiceActionForm.reason) = $event)),
                                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                                        placeholder: _unref(t)('settings.billing.fields.invoice_action_reason')
                                                    }, null, 8, _hoisted_127), [
                                                        [
                                                            _vModelText,
                                                            invoiceActionForm.reason,
                                                            void 0,
                                                            { trim: true }
                                                        ]
                                                    ])
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(store).platformInvoices.length > 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).platformInvoices, (invoice) => {
                                                        return (_openBlock(), _createElementBlock("article", {
                                                            key: invoice.id,
                                                            class: "rounded-lg border border-ewhite-100 p-3 text-sm"
                                                        }, [
                                                            _createElementVNode("div", _hoisted_129, [
                                                                _createElementVNode("div", null, [
                                                                    _createElementVNode("p", _hoisted_130, " #" + _toDisplayString(invoice.id) + " · " + _toDisplayString(_unref(invoiceLabel)(invoice.status)), 1),
                                                                    _createElementVNode("p", _hoisted_131, _toDisplayString(_unref(money)(invoice.total_minor, invoice.currency)) + " · " + _toDisplayString(_unref(dateLabel)(invoice.created_at)), 1)
                                                                ]),
                                                                (invoice.proof.evidence_url)
                                                                    ? (_openBlock(), _createElementBlock("a", {
                                                                        key: 0,
                                                                        href: invoice.proof.evidence_url,
                                                                        target: "_blank",
                                                                        rel: "noopener noreferrer",
                                                                        class: "text-xs font-semibold text-eorange-600 hover:underline"
                                                                    }, _toDisplayString(_unref(t)("settings.billing.actions.view_proof")), 9, _hoisted_132))
                                                                    : _createCommentVNode("", true)
                                                            ]),
                                                            (invoice.proof.status)
                                                                ? (_openBlock(), _createElementBlock("p", _hoisted_133, [
                                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.detail.proof_status")) + ": " + _toDisplayString(invoice.proof.status) + " ", 1),
                                                                    (invoice.proof.reference)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_134, "· " + _toDisplayString(invoice.proof.reference), 1))
                                                                        : _createCommentVNode("", true)
                                                                ]))
                                                                : _createCommentVNode("", true),
                                                            (invoice.proof.status === 'submitted')
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_135, [
                                                                    _createElementVNode("button", {
                                                                        type: "button",
                                                                        class: "h-8 rounded-lg border border-egreen-200 bg-white px-3 text-xs font-semibold text-egreen-700 hover:bg-egreen-50 disabled:opacity-60",
                                                                        disabled: _unref(store).isSaving || !invoiceActionForm.reason,
                                                                        "data-test": "billing-approve-proof",
                                                                        onClick: ($event) => (markHistoryInvoicePaid(invoice.id))
                                                                    }, _toDisplayString(_unref(t)("settings.billing.actions.mark_paid")), 9, _hoisted_136),
                                                                    _createElementVNode("button", {
                                                                        type: "button",
                                                                        class: "h-8 rounded-lg border border-red-200 bg-white px-3 text-xs font-semibold text-red-700 hover:bg-red-50 disabled:opacity-60",
                                                                        disabled: _unref(store).isSaving || !invoiceActionForm.reason,
                                                                        "data-test": "billing-reject-proof",
                                                                        onClick: ($event) => (rejectInvoiceProof(invoice.id))
                                                                    }, _toDisplayString(_unref(t)("settings.billing.actions.reject_proof")), 9, _hoisted_137)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ]));
                                                    }), 128))
                                                ]))
                                                : _createCommentVNode("", true)
                                        ])
                                    ]),
                                    _createElementVNode("section", _hoisted_138, [
                                        _createElementVNode("div", _hoisted_139, [
                                            _createElementVNode("div", null, [
                                                _createElementVNode("p", _hoisted_140, _toDisplayString(_unref(t)("settings.billing.provider.title")), 1),
                                                _createElementVNode("h3", _hoisted_141, _toDisplayString(providerName(selected.value)), 1),
                                                _createElementVNode("p", _hoisted_142, _toDisplayString(providerStatusLabel(selected.value)), 1)
                                            ]),
                                            _createElementVNode("span", {
                                                class: _normalizeClass(["rounded-full px-2 py-0.5 text-xs font-semibold",
                                                    selected.value.provider.enabled
                                                        ? 'bg-egreen-100 text-egreen-700'
                                                        : 'bg-ewhite-100 text-eblack-500'
                                                ])
                                            }, _toDisplayString(selected.value.provider.enabled
                                                ? _unref(t)("settings.billing.provider.enabled")
                                                : _unref(t)("settings.billing.provider.not_enabled")), 3)
                                        ]),
                                        (!canUseProviderBilling.value)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_143, _toDisplayString(_unref(t)("settings.billing.provider.disabled_warning")), 1))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("dl", _hoisted_144, [
                                            _createElementVNode("div", _hoisted_145, [
                                                _createElementVNode("dt", _hoisted_146, _toDisplayString(_unref(t)("settings.billing.provider.mode")), 1),
                                                _createElementVNode("dd", _hoisted_147, _toDisplayString(selected.value.provider.provider_mode || _unref(t)("settings.billing.none")), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_148, [
                                                _createElementVNode("dt", _hoisted_149, _toDisplayString(_unref(t)("settings.billing.provider.setup_status")), 1),
                                                _createElementVNode("dd", _hoisted_150, _toDisplayString(selected.value.provider.subscription.setup_status ||
                                                    selected.value.provider.account.setup_status ||
                                                    _unref(t)("settings.billing.none")), 1)
                                            ]),
                                            (selected.value.provider.account.provider_customer_id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                                    _createElementVNode("dt", _hoisted_152, _toDisplayString(_unref(t)("settings.billing.provider.customer_id")), 1),
                                                    _createElementVNode("dd", _hoisted_153, _toDisplayString(selected.value.provider.account.provider_customer_id), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (selected.value.provider.subscription.provider_subscription_id)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                                    _createElementVNode("dt", _hoisted_155, _toDisplayString(_unref(t)("settings.billing.provider.subscription_id")), 1),
                                                    _createElementVNode("dd", _hoisted_156, _toDisplayString(selected.value.provider.subscription.provider_subscription_id), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (providerLastError(selected.value))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_157, [
                                                    _createElementVNode("dt", _hoisted_158, _toDisplayString(_unref(t)("settings.billing.provider.last_error")), 1),
                                                    _createElementVNode("dd", _hoisted_159, _toDisplayString(providerLastError(selected.value)), 1)
                                                ]))
                                                : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_160, [
                                            _createElementVNode("label", _hoisted_161, [
                                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.reason")) + " ", 1),
                                                _withDirectives(_createElementVNode("textarea", {
                                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((providerActionForm.reason) = $event)),
                                                    class: "min-h-16 rounded-md border border-ewhite-200 px-3 py-2 text-sm",
                                                    placeholder: _unref(t)('settings.billing.provider.reason_placeholder')
                                                }, null, 8, _hoisted_162), [
                                                    [
                                                        _vModelText,
                                                        providerActionForm.reason,
                                                        void 0,
                                                        { trim: true }
                                                    ]
                                                ])
                                            ]),
                                            _createElementVNode("label", _hoisted_163, [
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((providerActionForm.cancel_at_period_end) = $event)),
                                                    type: "checkbox"
                                                }, null, 512), [
                                                    [_vModelCheckbox, providerActionForm.cancel_at_period_end]
                                                ]),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.provider.cancel_period_end")), 1)
                                            ]),
                                            _createElementVNode("div", _hoisted_164, [
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                    disabled: !canRunProviderAction.value,
                                                    "data-test": "billing-provider-migrate",
                                                    onClick: _cache[14] || (_cache[14] = ($event) => (requestProviderAction('migrate')))
                                                }, _toDisplayString(_unref(t)("settings.billing.provider.migrate")), 9, _hoisted_165),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                    disabled: !canRunProviderAction.value || !selected.value.provider.enabled,
                                                    "data-test": "billing-provider-sync",
                                                    onClick: syncProvider
                                                }, _toDisplayString(_unref(t)("settings.billing.provider.sync")), 9, _hoisted_166),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                    disabled: !canRunProviderAction.value || !selected.value.provider.enabled,
                                                    "data-test": "billing-provider-sync-seats",
                                                    onClick: _cache[15] || (_cache[15] = ($event) => (requestProviderAction('sync-seats')))
                                                }, _toDisplayString(_unref(t)("settings.billing.provider.sync_seats")), 9, _hoisted_167),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                    disabled: !canRunProviderAction.value ||
                                                        !selected.value.provider.enabled ||
                                                        !updateForm.plan_id,
                                                    "data-test": "billing-provider-change-plan",
                                                    onClick: _cache[16] || (_cache[16] = ($event) => (requestProviderAction('change-plan')))
                                                }, _toDisplayString(_unref(t)("settings.billing.provider.change_plan")), 9, _hoisted_168),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "h-9 rounded-lg border border-red-200 bg-white px-3 text-sm font-medium text-red-700 hover:bg-red-50 disabled:opacity-60 sm:col-span-2",
                                                    disabled: !canRunProviderAction.value || !selected.value.provider.enabled,
                                                    "data-test": "billing-provider-cancel",
                                                    onClick: _cache[17] || (_cache[17] = ($event) => (requestProviderAction('cancel')))
                                                }, _toDisplayString(_unref(t)("settings.billing.provider.cancel")), 9, _hoisted_169)
                                            ])
                                        ])
                                    ]),
                                    _createElementVNode("section", _hoisted_170, [
                                        _createElementVNode("h3", _hoisted_171, _toDisplayString(_unref(t)("settings.billing.detail.update_title")), 1),
                                        _createElementVNode("div", _hoisted_172, [
                                            _createElementVNode("label", _hoisted_173, [
                                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.plan")) + " ", 1),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((updateForm.plan_id) = $event)),
                                                    class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm",
                                                    "data-test": "billing-plan-select"
                                                }, [
                                                    _createElementVNode("option", _hoisted_174, _toDisplayString(_unref(t)("settings.billing.none")), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activePlans.value, (plan) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: plan.id,
                                                            value: plan.id
                                                        }, _toDisplayString(plan.name) + " - " + _toDisplayString(_unref(money)(plan.price.unit_amount_minor, plan.price.currency)), 9, _hoisted_175));
                                                    }), 128))
                                                ], 512), [
                                                    [_vModelSelect, updateForm.plan_id]
                                                ])
                                            ]),
                                            _createElementVNode("label", _hoisted_176, [
                                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.price_version")) + " ", 1),
                                                _withDirectives(_createElementVNode("select", {
                                                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event) => ((updateForm.plan_price_id) = $event)),
                                                    class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm",
                                                    "data-test": "billing-price-select"
                                                }, [
                                                    _createElementVNode("option", _hoisted_177, _toDisplayString(_unref(t)("settings.billing.fields.latest_price")), 1),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedPlanPriceVersions.value, (price) => {
                                                        return (_openBlock(), _createElementBlock("option", {
                                                            key: price.id,
                                                            value: price.id
                                                        }, _toDisplayString(_unref(money)(price.unit_amount_minor, price.currency)) + " - " + _toDisplayString(_unref(dateLabel)(price.effective_from)), 9, _hoisted_178));
                                                    }), 128))
                                                ], 512), [
                                                    [_vModelSelect, updateForm.plan_price_id]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_179, [
                                                _createElementVNode("label", _hoisted_180, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.status")) + " ", 1),
                                                    _withDirectives(_createElementVNode("select", {
                                                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((updateForm.status) = $event)),
                                                        class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm"
                                                    }, [
                                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusOptions, (status) => {
                                                            return _createElementVNode("option", {
                                                                key: status,
                                                                value: status
                                                            }, _toDisplayString(_unref(statusLabel)(status)), 9, _hoisted_181);
                                                        }), 64))
                                                    ], 512), [
                                                        [_vModelSelect, updateForm.status]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("label", _hoisted_182, [
                                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.billable_seats")) + " ", 1),
                                                _withDirectives(_createElementVNode("input", {
                                                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event) => ((updateForm.billable_seat_count) = $event)),
                                                    min: "0",
                                                    type: "number",
                                                    class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm"
                                                }, null, 512), [
                                                    [
                                                        _vModelText,
                                                        updateForm.billable_seat_count,
                                                        void 0,
                                                        { number: true }
                                                    ]
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_183, [
                                                _createElementVNode("label", _hoisted_184, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.custom_amount")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((updateForm.custom_amount) = $event)),
                                                        inputmode: "decimal",
                                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                                        placeholder: _unref(t)('settings.billing.fields.plan_price')
                                                    }, null, 8, _hoisted_185), [
                                                        [_vModelText, updateForm.custom_amount]
                                                    ])
                                                ]),
                                                _createElementVNode("label", _hoisted_186, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.currency")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event) => ((updateForm.custom_currency) = $event)),
                                                        maxlength: "3",
                                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm uppercase"
                                                    }, null, 512), [
                                                        [
                                                            _vModelText,
                                                            updateForm.custom_currency,
                                                            void 0,
                                                            { trim: true }
                                                        ]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_187, [
                                                _createElementVNode("label", _hoisted_188, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.trial")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event) => ((updateForm.trial_ends_at) = $event)),
                                                        type: "date",
                                                        class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm"
                                                    }, null, 512), [
                                                        [_vModelText, updateForm.trial_ends_at]
                                                    ])
                                                ]),
                                                _createElementVNode("label", _hoisted_189, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.grace")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event) => ((updateForm.grace_ends_at) = $event)),
                                                        type: "date",
                                                        class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm"
                                                    }, null, 512), [
                                                        [_vModelText, updateForm.grace_ends_at]
                                                    ])
                                                ]),
                                                _createElementVNode("label", _hoisted_190, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.cancel")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((updateForm.cancel_at) = $event)),
                                                        type: "date",
                                                        class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm"
                                                    }, null, 512), [
                                                        [_vModelText, updateForm.cancel_at]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("label", _hoisted_191, [
                                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.reason")) + " ", 1),
                                                _withDirectives(_createElementVNode("textarea", {
                                                    "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event) => ((updateForm.reason) = $event)),
                                                    class: "min-h-20 rounded-md border border-ewhite-200 px-3 py-2 text-sm",
                                                    placeholder: _unref(t)('settings.billing.fields.reason_placeholder')
                                                }, null, 8, _hoisted_192), [
                                                    [
                                                        _vModelText,
                                                        updateForm.reason,
                                                        void 0,
                                                        { trim: true }
                                                    ]
                                                ])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "inline-flex h-9 items-center justify-center gap-2 rounded-lg bg-eblack-900 px-3 text-sm font-semibold text-white hover:bg-eblack-800 disabled:opacity-60",
                                                disabled: _unref(store).isSaving || !updateForm.reason,
                                                "data-test": "billing-update",
                                                onClick: saveSubscription
                                            }, [
                                                _createVNode(_unref(IconDeviceFloppy), { class: "h-4 w-4" }),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.actions.save")), 1)
                                            ], 8, _hoisted_193)
                                        ])
                                    ]),
                                    _createElementVNode("section", _hoisted_194, [
                                        _createElementVNode("h3", _hoisted_195, _toDisplayString(_unref(t)("settings.billing.detail.preview_title")), 1),
                                        _createElementVNode("div", _hoisted_196, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((previewForm.plan_id) = $event)),
                                                class: "h-9 rounded-md border border-ewhite-200 px-2 text-sm",
                                                "data-test": "billing-preview-plan"
                                            }, [
                                                _createElementVNode("option", _hoisted_197, _toDisplayString(_unref(t)("settings.billing.fields.current_plan")), 1),
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activePlans.value, (plan) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: plan.id,
                                                        value: plan.id
                                                    }, _toDisplayString(plan.name), 9, _hoisted_198));
                                                }), 128))
                                            ], 512), [
                                                [_vModelSelect, previewForm.plan_id]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event) => ((previewForm.billable_seat_count) = $event)),
                                                min: "0",
                                                type: "number",
                                                class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                                "aria-label": _unref(t)('settings.billing.fields.billable_seats')
                                            }, null, 8, _hoisted_199), [
                                                [
                                                    _vModelText,
                                                    previewForm.billable_seat_count,
                                                    void 0,
                                                    { number: true }
                                                ]
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "h-9 rounded-lg border border-ewhite-200 px-3 text-sm font-medium text-eblack-700 hover:bg-ewhite-50 disabled:opacity-60",
                                                disabled: _unref(store).isSaving,
                                                "data-test": "billing-preview",
                                                onClick: previewCharge
                                            }, _toDisplayString(_unref(t)("settings.billing.actions.preview")), 9, _hoisted_200)
                                        ]),
                                        (_unref(store).latestPreview)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_201, [
                                                _createElementVNode("div", _hoisted_202, [
                                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("settings.billing.preview.proration")), 1),
                                                    _createElementVNode("strong", null, _toDisplayString(_unref(money)(_unref(store).latestPreview.proration_total_minor, _unref(store).latestPreview.currency)), 1)
                                                ]),
                                                _createElementVNode("div", _hoisted_203, [
                                                    _createElementVNode("span", null, _toDisplayString(_unref(t)("settings.billing.preview.next_invoice")), 1),
                                                    _createElementVNode("strong", null, _toDisplayString(_unref(money)(_unref(store).latestPreview.next_invoice_amount_minor, _unref(store).latestPreview.currency)), 1)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("section", _hoisted_204, [
                                        _createElementVNode("h3", _hoisted_205, _toDisplayString(_unref(t)("settings.billing.detail.invoice_title")), 1),
                                        _createElementVNode("div", _hoisted_206, [
                                            _createElementVNode("div", _hoisted_207, [
                                                _createElementVNode("label", _hoisted_208, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.amount")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event) => ((invoiceForm.amount) = $event)),
                                                        inputmode: "decimal",
                                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                                        "data-test": "billing-invoice-amount",
                                                        placeholder: "0.00"
                                                    }, null, 512), [
                                                        [_vModelText, invoiceForm.amount]
                                                    ])
                                                ]),
                                                _createElementVNode("label", _hoisted_209, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.currency")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event) => ((invoiceForm.currency) = $event)),
                                                        maxlength: "3",
                                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm uppercase"
                                                    }, null, 512), [
                                                        [
                                                            _vModelText,
                                                            invoiceForm.currency,
                                                            void 0,
                                                            { trim: true }
                                                        ]
                                                    ])
                                                ])
                                            ]),
                                            _createElementVNode("label", _hoisted_210, [
                                                _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.reason")) + " ", 1),
                                                _withDirectives(_createElementVNode("textarea", {
                                                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event) => ((invoiceForm.reason) = $event)),
                                                    class: "min-h-16 rounded-md border border-ewhite-200 px-3 py-2 text-sm",
                                                    placeholder: _unref(t)('settings.billing.fields.invoice_reason_placeholder')
                                                }, null, 8, _hoisted_211), [
                                                    [
                                                        _vModelText,
                                                        invoiceForm.reason,
                                                        void 0,
                                                        { trim: true }
                                                    ]
                                                ])
                                            ]),
                                            _createElementVNode("button", {
                                                type: "button",
                                                class: "inline-flex h-9 items-center justify-center gap-2 rounded-lg bg-eorange-500 px-3 text-sm font-semibold text-white hover:bg-eorange-600 disabled:opacity-60",
                                                disabled: _unref(store).isSaving || !canCreateInvoice.value,
                                                "data-test": "billing-create-invoice",
                                                onClick: createManualInvoice
                                            }, [
                                                _createVNode(_unref(IconReceipt), { class: "h-4 w-4" }),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)("settings.billing.actions.create_invoice")), 1)
                                            ], 8, _hoisted_212)
                                        ]),
                                        (selected.value.invoice.id)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_213, [
                                                _createElementVNode("div", _hoisted_214, [
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("p", _hoisted_215, _toDisplayString(_unref(t)("settings.billing.detail.latest_invoice")), 1),
                                                        _createElementVNode("p", _hoisted_216, _toDisplayString(_unref(invoiceLabel)(selected.value.invoice.status || "")) + " - " + _toDisplayString(_unref(money)(selected.value.invoice.total_minor, selected.value.amounts.currency)), 1)
                                                    ])
                                                ]),
                                                _createElementVNode("label", _hoisted_217, [
                                                    _createTextVNode(_toDisplayString(_unref(t)("settings.billing.fields.reason")) + " ", 1),
                                                    _withDirectives(_createElementVNode("input", {
                                                        "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event) => ((invoiceActionForm.reason) = $event)),
                                                        class: "h-9 rounded-md border border-ewhite-200 px-3 text-sm",
                                                        placeholder: _unref(t)('settings.billing.fields.invoice_action_reason')
                                                    }, null, 8, _hoisted_218), [
                                                        [
                                                            _vModelText,
                                                            invoiceActionForm.reason,
                                                            void 0,
                                                            { trim: true }
                                                        ]
                                                    ])
                                                ]),
                                                _createElementVNode("div", _hoisted_219, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "h-9 rounded-lg border border-egreen-200 bg-white px-3 font-medium text-egreen-700 hover:bg-egreen-50 disabled:opacity-60",
                                                        disabled: _unref(store).isSaving || !canMarkInvoicePaid.value,
                                                        "data-test": "billing-mark-paid",
                                                        onClick: markInvoicePaid
                                                    }, _toDisplayString(_unref(t)("settings.billing.actions.mark_paid")), 9, _hoisted_220),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "h-9 rounded-lg border border-red-200 bg-white px-3 font-medium text-red-700 hover:bg-red-50 disabled:opacity-60",
                                                        disabled: _unref(store).isSaving || !canVoidInvoice.value,
                                                        "data-test": "billing-void-invoice",
                                                        onClick: voidInvoice
                                                    }, _toDisplayString(_unref(t)("settings.billing.actions.void_invoice")), 9, _hoisted_221)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ])
                                ], 64))
                    ])
                ]),
                (pendingProviderAction.value)
                    ? (_openBlock(), _createBlock(ConfirmModal, {
                        key: 1,
                        title: _unref(t)('settings.billing.provider.confirm_title'),
                        message: pendingProviderActionMessage.value,
                        "confirm-text": _unref(t)('common.actions.confirm'),
                        "cancel-text": _unref(t)('common.actions.cancel'),
                        "is-confirming": _unref(store).isSaving,
                        variant: "danger",
                        "data-test": "billing-provider-confirm-modal",
                        onConfirm: runPendingProviderAction,
                        onCancel: _cache[34] || (_cache[34] = ($event) => (pendingProviderAction.value = null))
                    }, null, 8, ["title", "message", "confirm-text", "cancel-text", "is-confirming"]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
